module.exports = __webpack_public_path__ + "img/import-excel.c2d80050.png";